"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConvAiStoredSecretDependencies = void 0;
const core = __importStar(require("../../core"));
const ConvAiStoredSecretDependenciesToolsItem_1 = require("./ConvAiStoredSecretDependenciesToolsItem");
const ConvAiStoredSecretDependenciesAgentsItem_1 = require("./ConvAiStoredSecretDependenciesAgentsItem");
const SecretDependencyType_1 = require("./SecretDependencyType");
const DependentPhoneNumberIdentifier_1 = require("./DependentPhoneNumberIdentifier");
exports.ConvAiStoredSecretDependencies = core.serialization.object({
    tools: core.serialization.list(ConvAiStoredSecretDependenciesToolsItem_1.ConvAiStoredSecretDependenciesToolsItem),
    agents: core.serialization.list(ConvAiStoredSecretDependenciesAgentsItem_1.ConvAiStoredSecretDependenciesAgentsItem),
    others: core.serialization.list(SecretDependencyType_1.SecretDependencyType),
    phoneNumbers: core.serialization.property("phone_numbers", core.serialization.list(DependentPhoneNumberIdentifier_1.DependentPhoneNumberIdentifier).optional()),
});
